import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { DropDownButton } from "@tql/ui-components-react/tql/buttons";
import { dotsVertical } from "@tql/ui-components-react/untitled/icons";

import type { TrackingMessageAction } from "~/features/shipment-management/utils/constants.ts";
import type { ShipmentRemark } from "~/shared/schemas/shipment-management-schema";

export const RemarkItem = ({
	remark,
	onSelect,
	actions,
	isSaving,
}: {
	remark: ShipmentRemark;
	onSelect: (remark: ShipmentRemark, action: TrackingMessageAction) => void;
	actions: TrackingMessageAction[];
	isSaving: boolean;
}) => {
	// Legacy endpoint returns local wall-clock time, so parse it as local (no
	// UTC 'Z' conversion).
	const dateTimeFormatter = new Date(remark.dateEntered).toLocaleString(
		"en-US",
		{
			month: "2-digit",
			day: "2-digit",
			year: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
		},
	);
	return (
		<div className={"tracking-item"}>
			<div className={"tracking-item-header"}>
				<div className={"tracking-entered-by-text"}>
					{remark.contactInfo.name}
				</div>
				<div className={"tracking-date-text"}>{dateTimeFormatter}</div>
			</div>
			<div className={"tracking-item-body"}>
				<div className={"tracking-note-text"}>{remark.text}</div>
				{actions.length > 0 ? (
					<DropDownButton
						ariaLabel={"Remark actions"}
						className={"tracking-action-button"}
						disabled={isSaving}
						items={actions}
						onItemClick={(e: { item: TrackingMessageAction }) => {
							onSelect(remark, e.item);
						}}
						text={<SvgIcon icon={dotsVertical} size={"large"} />}
					/>
				) : (
					<div aria-hidden={true} className={"tracking-action-placeholder"} />
				)}
			</div>
		</div>
	);
};
